import axios from "axios";
import {
  Loading
} from "element-ui";
import store from "@/store";
import { toastError, formatApiErrorMessage } from "@/utils/toast";
import {
  getToken
} from "@/utils/auth";

import crypto from "@/utils/crypto"
import md5 from 'js-md5';

// const token = getToken();
window.location.contextPath = '';

const isDev = process.env.NODE_ENV === 'development'

function getDeviceRequestType() {
  const ua = navigator.userAgent || ''
  const mobileByUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)
  const mobileByWidth = window.innerWidth <= 768
  return mobileByUa || mobileByWidth ? 2 : 1
}

const service = axios.create({
  baseURL: window.location.contextPath,
  // Local proxy to remote API is often slow/unstable; fail faster in development.
  timeout: isDev ? 15000 : 30000,
  // onDownloadProgress: (progressEvent) => {
  //   const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
  //   console.log(`下载进度：${progress}%`);
  // }
});

let loadingInstance = null;
let loadingSeq = 0;
const pendingLoadingIds = new Set();

function ensureLoadingOpen() {
  if (!loadingInstance) {
    loadingInstance = Loading.service({
      lock: true,
      text: '',
      spinner: '',
      customClass: 'api-loading-mask'
    });
  }
}

function addLoadingRequest(config) {
  const id = `ld_${Date.now()}_${++loadingSeq}`;
  config.__loadingId = id;
  pendingLoadingIds.add(id);
  ensureLoadingOpen();
}

function removeLoadingRequest(config) {
  const id = config && config.__loadingId;
  if (id) {
    pendingLoadingIds.delete(id);
  }
  if (pendingLoadingIds.size === 0 && loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
}

function forceClearLoading() {
  pendingLoadingIds.clear();
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
}

service.interceptors.request.use(
  (config) => {
    try {
      if (config && config.loading === true) {
        config.__withLoading = true;
        addLoadingRequest(config);
      }
      let uuid = ''
      if (localStorage.getItem('uuid')) {
        uuid = localStorage.getItem('uuid')
      }
      let pg_game_str = 'pg_@13%4^5&_game'
      if (localStorage.getItem('salt')) {
        pg_game_str = localStorage.getItem('salt')
      }
      // if (config.auth && token) {
      //   config.headers["access-token"] = token
      // }
      // console.log(config);
      // if (token) {
      // config.headers["x-auth-token"] = token
      // config.headers["access_token"] = token
      // }
      let { method = 'get', data, params, url, header } = config;
      method = String(method).toLowerCase();
      if (!data || typeof data !== 'object') {
        data = {};
      }
      data.time = parseInt(new Date().getTime() / 1000)
      data.t = getDeviceRequestType()
      if (url.indexOf('mock') > -1) {
        return config;
      }
      if (method === "post") {
        // 对象的key排序
        var newkey = Object.keys(data).sort();
        let param_str = "";
        for (var i = 0; i < newkey.length; i++) {
          if (param_str == "")
            param_str = newkey[i] + "=" + data[newkey[i]];
          else
            param_str = param_str + "&" + newkey[i] + "=" + data[newkey[i]];
        }
        config.headers["token"] = md5(uuid + param_str + pg_game_str)
        config.headers["access"] = uuid
        config.headers["api-type"] = 'web'
        // config.headers["Accept-Language"] = 'zh'
        config.headers["Accept-Language"] = 'id'//localStorage.getItem('lang')
        if (!config.code) {
          config.data = {
            code: crypto.setAES(JSON.stringify(data))
          };
        }
      }
      config.params = {
        ...params,
        ...(method === 'post' ? {} : { time: data.time, t: data.t }),
      };
      if (process.env.NODE_ENV === 'development') { // 开发环境
        // config.params.access_token = token;
      }
      return config;
    } catch (e) {
      if (config && config.__withLoading) {
        removeLoadingRequest(config);
      }
      return Promise.reject(e);
    }
  },
  (error) => {
    if (error && error.config && error.config.__withLoading) {
      removeLoadingRequest(error.config);
    } else {
      // 兜底，避免异常丢失 config 导致 loading 遗留
      forceClearLoading();
    }
    return Promise.reject(error);
  }
);

// 当前用户信息接口返回code:0

service.interceptors.response.use(
  (response) => {
    if (response && response.config && response.config.__withLoading) {
      removeLoadingRequest(response.config);
    }
    let res = response.data;
    if (!res || res.code !== 1) {
      let url = response.config.url; // 当前请求路径
      // 不做拦截的请求路径
      let list = [];
      let isPass = list.find(path => {
        if (url.indexOf(path) > -1) {
          return true;
        }
      })
      // if (!isPass && typeof res === 'string') { // 特殊字符导致浏览器无法将串转成对象时
      //   res = eval(`(${res})`);
      // }
      if ([401].includes(res.code)) {
        const msg = formatApiErrorMessage(res.message, 'Sesi berakhir, silakan login ulang')
        toastError(msg)
        store.dispatch('user/onUnauthorized')
        return Promise.reject(new Error(msg));
      } else if (!isPass && ![1, 401].includes(res.code)) {
        const urlPath = String(url || '')
        const isGameLaunch = urlPath.indexOf('/api/game/getgameurl') > -1
        const msg = formatApiErrorMessage(
          res.message,
          isGameLaunch ? 'Gagal masuk game. Silakan coba lagi nanti.' : 'Error'
        )
        toastError(msg)
        return Promise.reject(new Error(msg));
      } else {
        return res;
      }


    } else {
      let _data = JSON.parse(crypto.decryptAES(res.data))
      res.data = _data
      return res;
      // return res
    }
  }, (error) => {
    if (error && error.config && error.config.__withLoading) {
      removeLoadingRequest(error.config);
    } else {
      // 兜底，避免异常丢失 config 导致 loading 遗留
      forceClearLoading();
    }
    const status = error && error.response && error.response.status;
    const url = (error && error.config && error.config.url) || '';
    const code = (error && error.code) || '';
    const isTimeout = code === 'ECONNABORTED' || /timeout/i.test((error && error.message) || '');
    // 首页引导接口偶发网络/404/超时时不打断用户（代理未就绪或上游抖动）
    const silentPaths = [
      '/api/index/home',
      '/api/index/getnoticelist',
      '/api/index/gamecatelist',
      '/api/index/getnewlist',
      '/api/index/getconfig',
      '/api/index/userhaslogin',
      '/api/index/checkDUser',
      '/api/users/info'
    ];
    const isSilentPath = silentPaths.some((p) => url.indexOf(p) > -1);
    const isSilent = isSilentPath && (!status || status === 404 || status === 502 || status >= 500 || isTimeout);
    if (!isSilent) {
      toastError(error.message || 'Error')
    }
    return Promise.reject(error);
  }
);

export default service;
